export const WORK_EXPERIENCE_CONTENT = 'workExperience';
export const SUMMARY_CONTENT = 'summary';
export const ACCOMPLISHMENT_CONTENT = 'accomplishment';
export const AFFILIATION_CONTENT = 'affiliation';
export const CERTIFICATION_CONTENT = 'certification';
export const SKILL_CONTENT = 'skill';

export const ALPHA_CONTENT_API = 'alpha';
export const BETA_CONTENT_API = 'beta';

export const CONTENT_API_VERSION = 'v2';
export const SEARCH_CONTENT_API_VERSION = 'v2';
